import React from 'react';

const SVG = ({ style = {}, color = 'white', stroke = '#8a0000', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <circle cx="50%" cy="50%" r="50%" fill={color} />
    <path stroke={stroke} strokeWidth="4" fill="none" strokeLinejoin="round" d="M20,30 V70 H80 V30 H20 L50,50 L80,30 z" />
  </svg>
);

export default SVG;
